import React, { VFC } from 'react'
import { addClassName } from 'utils'

type Props = {
  className?: string
  href: string
}

const MoreButton: VFC<Props> = (props) => {
  return (
    <div
      className={`max-w-[245px] bg-custom-4 sm:max-w-[490px] lg:max-w-[352px] ${addClassName(
        props.className
      )}`}
    >
      <a
        className="text-white font-shippori-mincho text-[12.5px] font-medium block text-center leading-[40px] sm:leading-[80px] sm:text-[25px] lg:leading-[50px] lg:text-base"
        href={props.href}
        target="_blank"
        rel="noreferrer"
      >
        このブランドを詳しく見る
      </a>
    </div>
  )
}

export default MoreButton
